__turbopack_context__.v({
  "className": "Xh2pGq_className",
  "variable": "Xh2pGq_variable",
});
